import MicroModal from "micromodal";

export function drawer() {
  MicroModal.init();

  const buttons = document.querySelectorAll(".js-drawerButton");
  const header = document.getElementById("js-header");

  const closeDrawer = (button, modalId) => {
    button.setAttribute("aria-expanded", "false");
    MicroModal.close(modalId, {
      awaitCloseAnimation: true,
    });
    header?.classList.remove("is-open");
  };

  buttons.forEach((button) => {
    const modal = button.nextElementSibling.id;
    const drawer = button.closest(".c-drawer");

    button.addEventListener("click", () => {
      const currentAriaExpanded = button.getAttribute("aria-expanded");

      if (currentAriaExpanded === "false") {
        button.setAttribute("aria-expanded", "true");
        MicroModal.show(modal, {
          disableScroll: true, // ページスクロールを無効に
          awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
          onClose: () => {
            button.setAttribute("aria-expanded", "false");
            header?.classList.remove("is-open");
          },
        });
        header?.classList.add("is-open");
      } else {
        closeDrawer(button, modal);
      }
    });

    drawer?.querySelectorAll(".c-drawer__link").forEach((link) => {
      link.addEventListener("click", () => {
        if (button.getAttribute("aria-expanded") !== "true") {
          return;
        }
        closeDrawer(button, modal);
      });
    });
  });
}